import React from 'react';

export default {
  heroStroke: 'App',
  heroHeadline: 'We',
  heroFirstSideHeading: 'Front-end/Back-end',
  heroSecondSideHeading: 'Collaboration',
  singleSectionText:
    'No go-betweens. We are developers & experts, collaborating with clients who want the best for their business.',
  actionColSmall: 'What we do',
  actionColLarge: 'We are',
  actionColStroke: 'collabs',
  actionColTitle: "You're in the right place",
  actionColBody: (
    <span>
      We have long experience working with game-changers,
      challengers, and innovators.
      <br />
      <br />
      We don't get comfortable. And we don't compromise. We
      are proud professionals. And for every new project we
      take on, we take pride in building you the best
      possible solution. With swift and accurate delivery.
    </span>
  ),
  actionColData: {
    linkText: 'Learn more',
    headlineText: 'Work with us',
    firstTitle: 'New business enquiries',
    secondTitle: 'Work for us',
  },
  infoColSmall: 'What we do',
  infoColLarge: 'We are',
  infoColStroke: 'skills',
  infoColTitle: 'What we do',
  infoColBody:
    'We take you from idea, to finished high-grade product smoothly.' +
    ' From the initial step of hearing and reiterating on your idea. Researching and designing the best experience. Developing the most robust and efficient code. To finally making sure we have a good hand-over process, where you can safely kick back and enjoy the product you envisioned from day one.' +
    ' For each step on the way, we talk as much as you want. If you want, every day. We are agile, and we are uncompromising in delivering the best possible product for you.',
  infoColData: {
    'Design/UX': [
      'Research',
      'User experience',
      'Wireframes/prototypes',
      'Design template',
    ],
    Development: [
      'Frontend',
      'Backend',
      'Machine learning',
      'Augmented Reality',
    ],
    Maintenance: [
      'Hosting',
      'Support',
      'Project management',
      'Continuous development',
    ],
  },
};
